import type { ReactNode } from 'react'

import { Sheet } from 'src/design-system/ui'

import './business-portal-mobile-navigation.css'

/** The mobile rail stays mounted while closed, including agent sidebar state. */
export const BusinessPortalMobileNavigation = ({
  children,
  label,
  onOpenChange,
  open,
}: {
  children: ReactNode
  label: string
  onOpenChange: (open: boolean) => void
  open: boolean
}) => (
  <Sheet
    open={open}
    onOpenChange={onOpenChange}
    label={label}
    layout="workspace"
    className="business-portal-mobile-navigation"
  >
    {children}
  </Sheet>
)
